import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/selling/LeftMenu';
import Feature from '../components/selling/Feature';
import ContactUs from '../components/ContactUs';
import SellYourMachineIn30Days from '../components/SellYourMachineIn30Days';

const AuctionProcess = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('selling'),
      url: '/content/selling/auction-process',
    },
    {
      label: 'Açık Artırma Nedir?',
      url: '/content/selling/auction-process',
    },
  ];

  const items = [
    {
      title: 'Online Teklif Kolaylığı',
      description: 'Makinanız online açık artırmaya çıkar, Türkiye genelinden online teklif alır. Makinanıza gelen teklifleri onaylayabilir veya reddedebilirsiniz. Satış rakamını belirleyebilir, hızlıca makinanızı satabilirsiniz.',
      icon: 'fa-solid fa-hand-holding-dollar',
    },
    {
      title: 'Güvenilir ve Şeffaf Fiyat Teklifi',
      description: 'Açık artırmalara katılmak isteyen katılımcılardan Teminat Bedeli temin edilmektedir. Manipülasyonu engellemek ve güveni sağlamak amacıyla yapılan bu işlem, sadece ciddi alıcıların makinanıza teklif vermesinin teminatı olur.',
      icon: 'fa-solid fa-shield',
    },
    {
      title: '30 Gün İçinde Satış ve Devir',
      description: 'Düzenlediğimiz açık artırmalar ortalama 30 gün içinde sonuçlanır. Alıcı bütün ödemeyi yaptığı takdirde, makinayı sorun yaşamadan teslim edebilirsiniz. Mali, hukuki ve operasyonel işlerin tamamını iyiMakina.com halleder.',
      icon: 'fa-solid fa-handshake',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="auction-process" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Açık Artırma</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  iyiMakina.com üzerinden satışa çıkan makinalar online açık artırmalara dahil olur.
                  Makinalarını satmak isteyen makina sahipleri, online açık artırmalar aracılığıyla makinalarını olduğu gibi olduğu yerden satabilirler.
                </p>
                <p>
                  iyiMakina.com'da gerçekleşen tüm açık artırmalar önceden duyurulan gün ve saatte online olarak yapılır.
                  iyiMakina'da satıcılar; "Pazarlık Usulü" ve "Zaman Ayarlı Açık Artırma" olmak üzere iki çeşit açık artırma ile karşılaşabilirler. Satılığıa çıkarılan makinanın detaylarında bu durum açıkça belirtilir.
                </p>
              </div>
            </div>
            <div className="row mb-30 align-items-stretch">
              {
                _.map(items, (item, index) => (
                  <Feature key={index} data={item} />
                ))
              }
            </div>
            <SellYourMachineIn30Days />
            <ContactUs about="Açık Artırma Süreciyle" />
          </div>
        </div>
      </div>
    </main>
  );
};

AuctionProcess.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Açık Artırma Süreci',
    },
  };
};

AuctionProcess.Layout = Layout;

export default withTranslation('common')(AuctionProcess);
